import React, { useState } from 'react';
import styles from './OrderCard.module.css';

const OrderCard = ({ order, onUpdateStatus, onConfirmPayment, onOpenChat, onEditOrder }) => {
  const [showDetails, setShowDetails] = useState(false);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('pt-BR');
  };

  const handlePrint = () => {
    // --- LÓGICA DE IMPRESSÃO (MANTIDA IGUAL) ---
    const createReceiptHTML = () => {
      let html = '<h2>Casa de Carnes Bom Jesus</h2>';
      html += `<div style="font-size: 22px; font-weight: bold; margin-bottom: 5px; text-align: center;">PEDIDO N° ${order.orderNumber}</div>`;
      html += `<div style="font-size: 18px; font-weight: bold; margin-bottom: 5px; text-align: center;">${order.customerName}</div>`;
      html += `<div style="font-size: 16px; margin-bottom: 5px; text-align: center;">${order.customerId}</div>`;
      html += `Data: ${formatDate(order.timestamp)} - ${formatTime(order.timestamp)}<br>`;
      html += '<hr>';

      html += '<h3>Itens do Pedido</h3>';
      order.cart.forEach(item => {
        const itemTotal = item.quantity * item.price;
        html += `<div style="font-size: 16px; font-weight: bold; margin-bottom: 4px;">${item.quantity}x ${item.product} - R$ ${itemTotal.toFixed(2).replace('.', ',')}</div>`;
      });
      html += '<hr>';

      if (order.deliveryType === 'delivery' && order.address) {
        html += '<h3>Entrega</h3>';
        html += `<div style="font-size: 16px; font-weight: bold;">${order.address.streetAndNumber || ''}</div>`;
        html += `<div style="font-size: 16px; font-weight: bold;">${order.address.neighborhood || ''}</div>`;
        if (order.address.reference) {
          html += `Ref: ${order.address.reference}<br>`;
        }
        html += '<hr>';
      }

      if (order.observation) {
        html += '<h3>Observação</h3>';
        html += `<div style="font-size: 16px; font-weight: bold;">${order.observation}</div>`;
        html += '<hr>';
      }

      if (order.deliveryTime) {
        html += '<h3>Horário de Entrega</h3>';
        html += `<div style="font-size: 16px; font-weight: bold;">${order.deliveryTime}</div>`;
        html += '<hr>';
      }
      if (order.pickupTime) {
        html += '<h3>Horário de Retirada</h3>';
        html += `<div style="font-size: 16px; font-weight: bold;">${order.pickupTime}</div>`;
        html += '<hr>';
      }

      html += '<h3>Total</h3>';
      html += `Pagamento: ${order.paymentMethod}<br>`;
      if (order.deliveryType === 'delivery') {
        html += `Taxa de Entrega: R$ ${Number(order.deliveryFee || 0).toFixed(2).replace('.', ',')}<br>`;
      }
      if (order.paymentConfirmed) {
        html += '<div style="font-size: 18px; font-weight: bold; margin-top: 5px;">Status Pagamento: PAGO</div>';
      }
      html += `<div style="font-size: 24px; font-weight: bold; margin-top: 10px; text-align: right;">Total: R$ ${order.total.toFixed(2).replace('.', ',')}</div>`;

      return html;
    };
    const printContents = createReceiptHTML();

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write('<html><head><title>Imprimir Pedido</title>');
    doc.write(`<style> 
      @page { size: auto; margin: 0mm; }
      body { font-family: 'Courier New', Courier, monospace; margin: 0; padding: 5px; font-size: 14px; line-height: 1.2; width: 72mm; }
      h2, h3, p, strong, span, br, div { margin: 0; padding: 0; }
      h2 { font-size: 18px; text-align: center; margin-bottom: 5px; font-weight: bold; }
      h3 { font-size: 16px; text-transform: uppercase; margin-top: 10px; margin-bottom: 5px; border-top: 2px solid #000; padding-top: 5px; font-weight: bold; }
      hr { border: none; border-top: 2px solid #000; margin: 10px 0; }
      div, h3, p { page-break-inside: avoid; }
      @media print { html, body { height: auto !important; overflow: visible !important; } }
    </style>`);
    doc.write('</head><body>');
    doc.write(printContents);
    doc.write('</body></html>');
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => { document.body.removeChild(iframe); }, 500);
  };

  const isPix = order.paymentMethod && order.paymentMethod.toLowerCase().includes('pix');
  const deliveryTypeForStyle = order.deliveryType === 'counter' ? 'pickup' : order.deliveryType;
  const cardClass = `${styles.card} ${styles[deliveryTypeForStyle]} ${order.paymentConfirmed ? styles.paymentConfirmed : ''}`;

  const getFormattedFulfillmentDate = () => {
    if (!order.fulfillmentDate) return null;
    const [year, month, day] = order.fulfillmentDate.split('-');
    return `${day}/${month}/${year}`;
  };
  const fulfillmentDateFormatted = getFormattedFulfillmentDate();

  const renderActionButtons = () => {
    const isDelivery = order.deliveryType === 'delivery';
    
    // Botões comuns
    const printButton = <button key="print" onClick={(e) => { e.stopPropagation(); handlePrint(); }} className={styles.printBtn}>🖨️ Imprimir</button>;
    const handleCancel = (e) => {
      e.stopPropagation();
      const confirmed = window.confirm("Deseja realmente cancelar este pedido?");
      if (confirmed) {
        onUpdateStatus(order.id, 'canceled');
        alert("Pedido cancelado");
      }
    };
    const cancelButton = <button key="cancel" onClick={handleCancel} className={styles.cancelBtn}>❌ Cancelar</button>;
    const editButton = <button key="edit" onClick={(e) => { e.stopPropagation(); onEditOrder(order); }} className={styles.editBtn}>✏️ Editar</button>;
    const chatButton = onOpenChat ? <button key="chat" onClick={(e) => { e.stopPropagation(); onOpenChat(); }} className={styles.chatBtn}>💬 Chat</button> : null;

    // Fluxo para PIX não confirmado
    if (isPix && !order.paymentConfirmed) {
      return [
        <button key="confirmPayment" onClick={(e) => { e.stopPropagation(); onConfirmPayment(order.id); }} className={styles.confirmPaymentBtn}>
          ✅ Confirmar Pagamento
        </button>,
        chatButton, editButton, printButton, cancelButton
      ];
    }

    // Fluxo de Preparação e Entrega (Visto, Preparado, Saiu)
    if (isDelivery && order.status !== 'out_for_delivery') {
      return [
        <div key="deliveryActions" className={styles.deliveryActionsRow}>
          <button onClick={(e) => { e.stopPropagation(); onUpdateStatus(order.id, 'seen'); }} className={styles.seenBtn} disabled={order.status === 'seen' || order.status === 'prepared'}>
            👀 Visto
          </button>
          <button onClick={(e) => { e.stopPropagation(); onUpdateStatus(order.id, 'prepared'); }} className={styles.preparedBtn} disabled={order.status === 'prepared'}>
            👨‍🍳 Preparado
          </button>
          <button onClick={(e) => { e.stopPropagation(); onUpdateStatus(order.id, 'out_for_delivery'); }} className={styles.assignBtn} disabled={order.status !== 'prepared'}>
            🚀 Saiu
          </button>
        </div>,
        chatButton, editButton, printButton, cancelButton
      ];
    }

    // Fluxo para finalizar (Balcão/Retirada ou Entrega que já saiu)
    if ((isDelivery && order.status === 'out_for_delivery') || !isDelivery) {
      return [
        <button key="complete" onClick={(e) => { e.stopPropagation(); onUpdateStatus(order.id, 'completed'); }} className={styles.completeBtn}>
          🏁 Finalizar
        </button>,
        chatButton, editButton, printButton, cancelButton
      ];
    }

    return [chatButton, editButton, printButton, cancelButton];
  };

  const getDeliveryTypeLabel = () => {
    let label = '';
    if (order.deliveryType === 'delivery') label = '🛵 Entrega';
    else if (order.deliveryType === 'counter') label = '🏪 Balcão';
    else label = '🛍️ Retirada';

    // Adiciona o status se for relevante
    if (order.status === 'seen') {
      label += ' (Visto)';
    } else if (order.status === 'prepared') {
      label += ' (Preparado)';
    }

    // MELHORIA: Adiciona o horário diretamente na etiqueta para visualização rápida
    const time = order.deliveryTime || order.pickupTime;
    if (time) label += ` • ${time}`;

    return label;
  };

  return (
    <div className={cardClass} onClick={() => setShowDetails(prev => !prev)}>
      <div className={styles.header}>
        <div className={styles.customerInfo}>
          <span className={styles.customerName}>{order.customerName}</span>
          <div className={styles.orderMeta}>
            <span className={styles.orderNumber}>#{order.orderNumber}</span>
            {fulfillmentDateFormatted && (
              <span className={styles.fulfillmentDate}> • 📅 {fulfillmentDateFormatted}</span>
            )}
          </div>
        </div>
        <span className={styles.deliveryBadge}>{getDeliveryTypeLabel()}</span>
      </div>

      <div className={styles.body}>
        <div className={styles.itemList}>
          {order.cart.map((item, index) => (
            <div key={index} className={styles.itemRow}>
              <span className={styles.itemDescription}>{item.quantity}x {item.product}</span>
              <span className={styles.itemPrice}>R$ {(item.price * item.quantity).toFixed(2)}</span>
            </div>
          ))}
        </div>
        
        {showDetails && (
          <div className={styles.detailsContainer}>
            {order.deliveryType === 'delivery' && order.address && (
              <>
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>Endereço:</span>
                  <span className={styles.detailValue}>{order.address.streetAndNumber}</span>
                </div>
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>Bairro:</span>
                  <span className={styles.detailValue}>{order.address.neighborhood}</span>
                </div>
                {order.address.reference && (
                  <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>Ref:</span>
                    <span className={styles.detailValue}>{order.address.reference}</span>
                  </div>
                )}
              </>
            )}
            
            {order.deliveryTime && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Entrega:</span>
                <span className={styles.detailValue}>{order.deliveryTime}</span>
              </div>
            )}
            {order.pickupTime && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Retirada:</span>
                <span className={styles.detailValue}>{order.pickupTime}</span>
              </div>
            )}
            
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Pagamento:</span>
              <span className={styles.detailValue}>
                {order.paymentMethod} 
                {order.paymentConfirmed ? <span style={{color:'green', fontWeight:'bold', marginLeft:'4px'}}> (OK)</span> : <span style={{color:'#dc3545', marginLeft:'4px'}}> (Pendente)</span>}
              </span>
            </div>
            
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Tel:</span>
              <span className={styles.detailValue}>{order.customerId}</span>
            </div>

            {order.observation && (
              <div className={styles.observation}>
                <strong>Obs:</strong> {order.observation}
              </div>
            )}
          </div>
        )}
      </div>

      <div className={styles.footer}>
        <span className={styles.totalPrice}>R$ {order.total.toFixed(2)}</span>
        <span className={styles.timestamp}>{formatTime(order.timestamp)}</span>
      </div>

      {showDetails && (
        <div className={styles.actions}>
          {renderActionButtons()}
        </div>
      )}
    </div>
  );
};

export default OrderCard;
